import { render, staticRenderFns } from "./Donors.vue?vue&type=template&id=d642c458&"
import script from "./Donors.vue?vue&type=script&lang=js&"
export * from "./Donors.vue?vue&type=script&lang=js&"
import style0 from "./Donors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports